import React from "react";
import { Link } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';


const BlogCard = ({ id, title, description, date, image, loading }) => {
  return (
    <div className="blog-card">
      <div className="card-image">
        {loading ? (
          <Skeleton height={200} />
        ) : (
          <img src={image || "images/blog-1.jpg"} className="blog-img-el img-fluid w-100" alt="blog" />
        )}
      </div>

      <div className="blog-content">
        {loading ? (
          <Skeleton width="50%" height="20px" />
        ) : (
          <p className="date">{date}</p>
        )}
         
         <div className="blog-content-el">
         {loading ? (
          <Skeleton width="80%" height="25px" />
        ) : (
          <h5 className="title">{title}</h5>
        )}

        {loading ? (
          <Skeleton count={2} />
        ) : (
          <p
            className="desc"
            dangerouslySetInnerHTML={{
              __html: description?.substr(0, 70) + "...",
            }}
          ></p>
        )}
         </div>


        {!loading && (
          <Link to={"/blog/" + id} className="button">
            Read More
          </Link>
        )}
      </div>
    </div>
  );
};

export default BlogCard;
